import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LocalizationResource, LocalizationResourceCreate, LocalizationResourceFilter } from '../data/localizationResource';

export function createLocalizationResourceService(client: AxiosInstance) {
  return createCrudService<LocalizationResource, LocalizationResourceCreate, LocalizationResourceFilter>(
    client,
    '/platform/LocalizationResource',
    'id',
  );
}

export type LocalizationResourceService = CrudService<LocalizationResource, LocalizationResourceCreate, LocalizationResourceFilter>;
